import { ADD_SAVED_DAY } from "./actionTypes";

export default (date, savedCalendarId) => ({
  type: ADD_SAVED_DAY,
  payload: {
    date,
    savedCalendarId,
  },
});